/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { FooterLegalSection } from './FooterLegalSection';
import { FooterLinks } from './FooterLinks';
import { ClubAppLinks } from 'OneWestwingFooter/types';
import styled from 'styled-components';
import { Config, GaTrackingHelpers } from 'AppShell/appshell_types';
import { OwwFooterTrackingProvider } from 'OneWestwingFooter/providers/OwwFooterTrackingProvider';
import { FooterHelpInfo } from 'OneWestwingFooter/FooterHelpInfo';
import { OneWestwingFooterIds } from 'Common/qaIds';

const StyledFooter = styled.footer<{ $withMarginTop?: boolean }>`
    margin-top: ${({ $withMarginTop }) => ($withMarginTop ? '40px' : '0')};
    & ul {
        list-style-type: none;
    }
`;

const FooterLinksWrapper = styled.div<{ $isVisible: boolean }>`
    display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;

export interface OneWestwingFooterProps {
    hasSeoLinks?: boolean;
    isMiniMode?: boolean;
    isClub?: boolean;
    country: Config['countryCode'];
    trackingHelpers: GaTrackingHelpers;
    clubAppLinks?: ClubAppLinks;
}
const OneWestwingFooter: React.FC<OneWestwingFooterProps> = ({
    hasSeoLinks = false,
    isMiniMode = false,
    trackingHelpers,
    isClub = false,
    clubAppLinks,
}) => (
    <OwwFooterTrackingProvider value={trackingHelpers}>
        <StyledFooter $withMarginTop={!isMiniMode && !isClub} data-testid={OneWestwingFooterIds.owwFooter}>
            <FooterLinksWrapper $isVisible={!isMiniMode}>
                <FooterLinks hasSeoLinks={hasSeoLinks} isClub={isClub} clubAppLinks={clubAppLinks} />
            </FooterLinksWrapper>
            {isMiniMode && <FooterHelpInfo isClub={isClub} />}
            <FooterLegalSection isMiniMode={isMiniMode} isClub={isClub} />
        </StyledFooter>
    </OwwFooterTrackingProvider>
);

export default OneWestwingFooter;
